<template>
  <div class="background"></div>
  <div v-if="!initializing">
    <div class="header-movil fixed-top w-100 bg-primary d-md-none p-2">
      <div class="nombre-usuario text-secondary ms-2">{{ nombreUsuario }}</div>
      <div class="gestor-rooming ms-2">{{ $t('rooming.gestorRooming') }}</div>
    </div>

    <div class="top-block d-none d-md-flex usergestor-div">
      <div class="top-block-content">
        <div class="user-info">
          <div class="text-secondary nombre-usuario mb-2">{{ nombreUsuario }}</div>
          <div class="gestor-rooming">{{ $t('rooming.gestorRooming') }}</div>
        </div>
        <!-- <div class="social-links">
          <div class="review-link">
            <span>{{ $t('rooming.resena') }}</span>
            <div class="hvr-grow social-icon">
              <a
                href="https://www.google.com/search?sa=X&sca_esv=848dab325507aed5&sca_upv=1&hl=es-ES&tbm=lcl&sxsrf=ADLYWIIrTEc9LLvAtdZnf5_HRX-rXXGAHw:1721210574785&q=Travel%26Night+Rese%C3%B1as&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2NTezMLQwtjA2MzW3NLQ0Mzcw2sDI-IpRNKQosSw1R80vMz2jRCEotTj18MbE4kWs2MUB-tKVqkoAAAA&rldimm=5768183836579196702&ved=2ahUKEwjp55KH6a2HAxU1gP0HHT1rDJAQ9fQKegQIMxAF&biw=1918&bih=993&dpr=1#lkt=LocalPoiReviews"
                target="_blank"
                class="bg-secondary p-2 rounded-circle"
                aria-label="Google review link">
                <i class="fa-brands fa-google fa-lg"></i>
              </a>
            </div>
          </div>
          <div class="follow-links">
            <span>{{ $t('rooming.siguenos') }}</span>

            <div class="hvr-grow social-icon">
              <a
                href="https://www.linkedin.com/company/travelandnight"
                target="_blank"
                class="bg-secondary p-2 rounded-circle"
                aria-label="LinkedIn link">
                <i class="fa-brands fa-linkedin fa-lg"></i>
              </a>
            </div>
            <div class="hvr-grow social-icon">
              <a
                href="https://www.instagram.com/skiandnight"
                target="_blank"
                class="bg-secondary p-2 rounded-circle"
                aria-label="Instagram link">
                <i class="fa-brands fa-instagram fa-lg"></i>
              </a>
            </div>
            <div class="hvr-grow social-icon">
              <a
                href="https://www.facebook.com/skiandnight/"
                target="_blank"
                class="bg-secondary p-2 rounded-circle"
                aria-label="Facebook link">
                <i class="fa-brands fa-facebook fa-lg"></i>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div v-if="isMobile" class="rooming-list-mobile">
      <CarouselRooming :lista-roomings="fetchedDataRooming" @open-modal="openModal" />
    </div>

    <div v-else class="rooming-list pb-5 row g-4">
      <template v-for="room in fetchedDataRooming" :key="room.id">
        <div class="col-6 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
          <div class="card rooming-card position-relative overflow-hidden">
            <template v-if="room.estado == ESTADOS_ROOMING.NUEVO">
              <span class="badge bg-danger position-absolute new-badge">
                ¡{{ $t('rooming.estado.' + room.estado) }}!
              </span>
              <span class="badge bg-danger position-absolute new-badge">
                ¡{{ $t('rooming.estado.' + room.estado) }}!
              </span>
            </template>
            <img v-if="room.imagen" :src="room.imagen" class="card-img-top" alt="..." />
            <img v-else src="@/assets/img/fondo_mygocu.png" class="card-img-top" />
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <span class="card-title text-primary">{{ room.alojamiento }}</span>
                <span>
                  <button
                    type="button"
                    class="btn bg-transparent rotate-button"
                    :disabled="isLoadingModal && loadingModalId === room.id"
                    @click="openModal(room.id)">
                    <i v-if="!isLoadingModal" class="fa-solid fa-ellipsis-vertical text-primary"></i>
                    <div v-else class="spinner-border spinner-border-sm text-primary" role="status"></div>
                  </button>
                </span>
              </div>
              <div class="card-text text-primary">
                <div class="row w-100 mx-auto">
                  <div class="col-1 p-0">
                    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.5 13.5C7.64834 13.5 7.79334 13.456 7.91668 13.3736C8.04002 13.2912 8.13614 13.1741 8.19291 13.037C8.24968 12.9 8.26453 12.7492 8.23559 12.6037C8.20665 12.4582 8.13522 12.3246 8.03033 12.2197C7.92544 12.1148 7.7918 12.0433 7.64632 12.0144C7.50083 11.9855 7.35003 12.0003 7.21299 12.0571C7.07594 12.1139 6.95881 12.21 6.8764 12.3333C6.79399 12.4567 6.75 12.6017 6.75 12.75C6.75 12.9489 6.82902 13.1397 6.96967 13.2803C7.11032 13.421 7.30109 13.5 7.5 13.5ZM11.25 13.5C11.3983 13.5 11.5433 13.456 11.6667 13.3736C11.79 13.2912 11.8861 13.1741 11.9429 13.037C11.9997 12.9 12.0145 12.7492 11.9856 12.6037C11.9566 12.4582 11.8852 12.3246 11.7803 12.2197C11.6754 12.1148 11.5418 12.0433 11.3963 12.0144C11.2508 11.9855 11.1 12.0003 10.963 12.0571C10.8259 12.1139 10.7088 12.21 10.6264 12.3333C10.544 12.4567 10.5 12.6017 10.5 12.75C10.5 12.9489 10.579 13.1397 10.7197 13.2803C10.8603 13.421 11.0511 13.5 11.25 13.5ZM11.25 10.5C11.3983 10.5 11.5433 10.456 11.6667 10.3736C11.79 10.2912 11.8861 10.1741 11.9429 10.037C11.9997 9.89997 12.0145 9.74917 11.9856 9.60368C11.9566 9.4582 11.8852 9.32456 11.7803 9.21967C11.6754 9.11478 11.5418 9.04335 11.3963 9.01441C11.2508 8.98547 11.1 9.00032 10.963 9.05709C10.8259 9.11386 10.7088 9.20998 10.6264 9.33332C10.544 9.45666 10.5 9.60166 10.5 9.75C10.5 9.94891 10.579 10.1397 10.7197 10.2803C10.8603 10.421 11.0511 10.5 11.25 10.5ZM7.5 10.5C7.64834 10.5 7.79334 10.456 7.91668 10.3736C8.04002 10.2912 8.13614 10.1741 8.19291 10.037C8.24968 9.89997 8.26453 9.74917 8.23559 9.60368C8.20665 9.4582 8.13522 9.32456 8.03033 9.21967C7.92544 9.11478 7.7918 9.04335 7.64632 9.01441C7.50083 8.98547 7.35003 9.00032 7.21299 9.05709C7.07594 9.11386 6.95881 9.20998 6.8764 9.33332C6.79399 9.45666 6.75 9.60166 6.75 9.75C6.75 9.94891 6.82902 10.1397 6.96967 10.2803C7.11032 10.421 7.30109 10.5 7.5 10.5ZM12.75 1.5H12V0.75C12 0.551088 11.921 0.360322 11.7803 0.21967C11.6397 0.0790176 11.4489 0 11.25 0C11.0511 0 10.8603 0.0790176 10.7197 0.21967C10.579 0.360322 10.5 0.551088 10.5 0.75V1.5H4.5V0.75C4.5 0.551088 4.42098 0.360322 4.28033 0.21967C4.13968 0.0790176 3.94891 0 3.75 0C3.55109 0 3.36032 0.0790176 3.21967 0.21967C3.07902 0.360322 3 0.551088 3 0.75V1.5H2.25C1.65326 1.5 1.08097 1.73705 0.65901 2.15901C0.237053 2.58097 0 3.15326 0 3.75V14.25C0 14.8467 0.237053 15.419 0.65901 15.841C1.08097 16.2629 1.65326 16.5 2.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V3.75C15 3.15326 14.7629 2.58097 14.341 2.15901C13.919 1.73705 13.3467 1.5 12.75 1.5ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H2.25C2.05109 15 1.86032 14.921 1.71967 14.7803C1.57902 14.6397 1.5 14.4489 1.5 14.25V7.5H13.5V14.25ZM13.5 6H1.5V3.75C1.5 3.55109 1.57902 3.36032 1.71967 3.21967C1.86032 3.07902 2.05109 3 2.25 3H3V3.75C3 3.94891 3.07902 4.13968 3.21967 4.28033C3.36032 4.42098 3.55109 4.5 3.75 4.5C3.94891 4.5 4.13968 4.42098 4.28033 4.28033C4.42098 4.13968 4.5 3.94891 4.5 3.75V3H10.5V3.75C10.5 3.94891 10.579 4.13968 10.7197 4.28033C10.8603 4.42098 11.0511 4.5 11.25 4.5C11.4489 4.5 11.6397 4.42098 11.7803 4.28033C11.921 4.13968 12 3.94891 12 3.75V3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967C13.421 3.36032 13.5 3.55109 13.5 3.75V6ZM3.75 10.5C3.89834 10.5 4.04334 10.456 4.16668 10.3736C4.29001 10.2912 4.38614 10.1741 4.44291 10.037C4.49968 9.89997 4.51453 9.74917 4.48559 9.60368C4.45665 9.4582 4.38522 9.32456 4.28033 9.21967C4.17544 9.11478 4.0418 9.04335 3.89632 9.01441C3.75083 8.98547 3.60003 9.00032 3.46299 9.05709C3.32594 9.11386 3.20881 9.20998 3.1264 9.33332C3.04399 9.45666 3 9.60166 3 9.75C3 9.94891 3.07902 10.1397 3.21967 10.2803C3.36032 10.421 3.55109 10.5 3.75 10.5ZM3.75 13.5C3.89834 13.5 4.04334 13.456 4.16668 13.3736C4.29001 13.2912 4.38614 13.1741 4.44291 13.037C4.49968 12.9 4.51453 12.7492 4.48559 12.6037C4.45665 12.4582 4.38522 12.3246 4.28033 12.2197C4.17544 12.1148 4.0418 12.0433 3.89632 12.0144C3.75083 11.9855 3.60003 12.0003 3.46299 12.0571C3.32594 12.1139 3.20881 12.21 3.1264 12.3333C3.04399 12.4567 3 12.6017 3 12.75C3 12.9489 3.07902 13.1397 3.21967 13.2803C3.36032 13.421 3.55109 13.5 3.75 13.5Z"
                        fill="var(--bs-primary)" />
                    </svg>
                  </div>
                  <div class="col-10 p-0 ms-2">
                    {{ formatDate(room.fechaInicio) }} - {{ formatDate(room.fechaFin) }}
                  </div>
                </div>
                <div class="row w-100 mx-auto">
                  <div class="col-1 p-0">
                    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.71502 5.95354C8.07932 5.6382 8.37152 5.24818 8.57178 4.80996C8.77205 4.37173 8.87569 3.89555 8.87569 3.41373C8.87569 2.50835 8.51603 1.64006 7.87583 0.999857C7.23563 0.35966 6.36734 1.22151e-07 5.46196 1.22151e-07C4.55659 1.22151e-07 3.68829 0.35966 3.04809 0.999857C2.4079 1.64006 2.04824 2.50835 2.04824 3.41373C2.04823 3.89555 2.15188 4.37173 2.35214 4.80996C2.55241 5.24818 2.84461 5.6382 3.2089 5.95354C2.25315 6.38632 1.44228 7.08521 0.873218 7.96664C0.30416 8.84808 0.0010049 9.87476 0 10.9239C0 11.105 0.0719319 11.2787 0.199971 11.4067C0.328011 11.5347 0.50167 11.6067 0.682745 11.6067C0.863821 11.6067 1.03748 11.5347 1.16552 11.4067C1.29356 11.2787 1.36549 11.105 1.36549 10.9239C1.36549 9.83747 1.79708 8.79552 2.56532 8.02728C3.33356 7.25904 4.37551 6.82745 5.46196 6.82745C6.54841 6.82745 7.59037 7.25904 8.35861 8.02728C9.12684 8.79552 9.55843 9.83747 9.55843 10.9239C9.55843 11.105 9.63037 11.2787 9.75841 11.4067C9.88645 11.5347 10.0601 11.6067 10.2412 11.6067C10.4223 11.6067 10.5959 11.5347 10.724 11.4067C10.852 11.2787 10.9239 11.105 10.9239 10.9239C10.9229 9.87476 10.6198 8.84808 10.0507 7.96664C9.48165 7.08521 8.67077 6.38632 7.71502 5.95354ZM5.46196 5.46196C5.05686 5.46196 4.66085 5.34183 4.32402 5.11677C3.98719 4.89171 3.72467 4.57182 3.56964 4.19755C3.41461 3.82329 3.37405 3.41145 3.45308 3.01414C3.53211 2.61682 3.72719 2.25186 4.01364 1.9654C4.30009 1.67895 4.66505 1.48388 5.06237 1.40485C5.45969 1.32582 5.87152 1.36638 6.24579 1.5214C6.62005 1.67643 6.93994 1.93896 7.16501 2.27579C7.39007 2.61262 7.5102 3.00862 7.5102 3.41373C7.5102 3.95695 7.2944 4.47793 6.91028 4.86205C6.52617 5.24617 6.00519 5.46196 5.46196 5.46196ZM12.1119 5.68044C12.5488 5.18841 12.8343 4.58057 12.9338 3.93011C13.0333 3.27965 12.9428 2.61428 12.673 2.0141C12.4032 1.41391 11.9657 0.904498 11.4131 0.547168C10.8605 0.189837 10.2165 -0.000175875 9.55843 1.22151e-07C9.37736 1.22151e-07 9.2037 0.071932 9.07566 0.199972C8.94762 0.328011 8.87569 0.50167 8.87569 0.682745C8.87569 0.863821 8.94762 1.03748 9.07566 1.16552C9.2037 1.29356 9.37736 1.36549 9.55843 1.36549C10.1017 1.36549 10.6226 1.58129 11.0068 1.9654C11.3909 2.34952 11.6067 2.8705 11.6067 3.41373C11.6057 3.77233 11.5106 4.1244 11.3309 4.43472C11.1512 4.74504 10.8931 5.00273 10.5826 5.18204C10.4813 5.24043 10.3968 5.32382 10.337 5.42423C10.2772 5.52465 10.2442 5.63872 10.2412 5.75554C10.2383 5.87145 10.265 5.98617 10.3188 6.0889C10.3725 6.19162 10.4516 6.27897 10.5484 6.3427L10.8147 6.52022L10.9034 6.56801C11.7264 6.95835 12.4207 7.57573 12.9046 8.34746C13.3884 9.11918 13.6416 10.0131 13.6344 10.9239C13.6344 11.105 13.7064 11.2787 13.8344 11.4067C13.9624 11.5347 14.1361 11.6067 14.3172 11.6067C14.4982 11.6067 14.6719 11.5347 14.7999 11.4067C14.928 11.2787 14.9999 11.105 14.9999 10.9239C15.0055 9.8762 14.7431 8.84445 14.2376 7.92671C13.7321 7.00897 13.0004 6.23573 12.1119 5.68044Z"
                        fill="var(--bs-primary)" />
                    </svg>
                  </div>
                  <div class="col-10 p-0 ms-2">{{ room.numPlazas }}</div>
                </div>
                <div v-if="room.estado !== ESTADOS_ROOMING.NUEVO" class="row mt-3 w-100 mx-auto">
                  <span class="badge estado" :style="getStyle(room.estado)">{{
                    $t('rooming.estado.' + room.estado)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <ModalRooming
      :rooming-data="selectedRoomingData"
      :estado-rooming="estadoRooming"
      :modal-active="modalActive"
      @actualizar="actualizarHabitaciones"
      @close-modal="modalActive = false" />
  </div>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { formatDate } from '@/helpers/dateUtiles';
  import ModalRooming from '@/components/modales/Rooming/ModalRooming.vue';
  import RoomingApiService from '@/services/api/RoomingApiService';
  import { ESTADOS_ROOMING, getClassEstadoRooming } from '@/constants/roomingConstants';
  import CarouselRooming from '@/components/Carousel/CarouselRooming.vue';
  import { Home } from 'src/router/RouterNames';
  import { useUserStore } from '@/store_pinia/userStore';
  import { useLoadingStore } from '@/store_pinia/loadingStore';

  const userStore = useUserStore();
  const loadingStore = useLoadingStore();
  const router = useRouter();

  const hasRoleGestorRooming = computed(() => userStore.hasRoleGestorRooming);

  const initializing = ref(true);
  const fetchedDataRooming = ref([]);
  const selectedRoomingData = ref({});
  const modalActive = ref(false);
  const isLoadingModal = ref(false);
  const loadingModalId = ref(null);

  const roomingData = ref([]);
  const estadoRooming = ref('EN_EDICION');

  const nombreUsuario = computed(() => {
    const user = userStore.getUsuario || { nombre: 'Usuario', apellidos: 'No disponible' };
    return `${user.nombre} ${user.apellidos}`;
  });

  const isMobile = ref(window.innerWidth <= 768);
  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 768;
  });

  function actualizarHabitaciones(nuevasHabitaciones) {
    roomingData.value = roomingData.value.map(alojamiento => {
      if (alojamiento.id === nuevasHabitaciones.id) {
        return { ...alojamiento, habitaciones: nuevasHabitaciones.habitaciones };
      }
      return alojamiento;
    });
  }

  async function openModal(id) {
    try {
      loadingStore.show();
      isLoadingModal.value = true;
      loadingModalId.value = id;

      selectedRoomingData.value = await RoomingApiService.getRoomingByID(id);
      estadoRooming.value = selectedRoomingData.value.estado;
      modalActive.value = true;
    } catch (error) {
      console.error('Error fetching rooming data:', error);
    } finally {
      isLoadingModal.value = false;
      loadingModalId.value = null;
      loadingStore.hide();
    }
  }

  function getStyle(estado) {
    const { textColor, bgColor } = getClassEstadoRooming(estado);
    return {
      color: textColor,
      backgroundColor: bgColor,
    };
  }

  function checkRoleGestorRoomingAndRedirect() {
    if (!hasRoleGestorRooming.value) {
      router.push({
        name: Home,
      });
    }
  }

  async function init() {
    try {
      loadingStore.show();
      checkRoleGestorRoomingAndRedirect();
      fetchedDataRooming.value = await RoomingApiService.getRoomingList();
    } catch (error) {
      console.error(error);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => await init());
</script>

<style scoped lang="scss">
  .top-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 132px;
    margin: 14rem 3.5rem 0 3.5rem;
    text-align: left;
    border-radius: var(--bs-border-radius-xl);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

    .top-block-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 15px;

      .user-info {
        padding-left: 20px;

        .nombre-usuario {
          font-size: 32px;
          font-weight: 600;
        }

        .gestor-rooming {
          color: #fff;
          font-size: 24px;
          font-weight: 500;
        }
      }

      .social-links {
        padding-right: 1rem;
        display: flex;
        gap: 10px;
        flex-direction: column;
        align-items: flex-end;

        .review-link,
        .follow-links {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          span {
            margin-right: 10px;
            color: #fff;
            font-size: 14px;
            font-weight: 500;
          }

          .social-icon {
            transition: 0.3s;
            margin-left: 10px;
          }
        }

        .review-link span,
        .follow-links span {
          display: inline-block;
        }

        .follow-links {
          margin-top: 10px;
          display: flex;

          .social-icon {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .hvr-grow {
    display: inline-block;
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    transition-duration: 0.3s;
    transition-property: transform;
  }

  .hvr-grow:hover,
  .hvr-grow:focus,
  .hvr-grow:active {
    transform: scale(1.1);
  }

  .header-movil {
    transition: 0.3s ease-in-out;
    z-index: 1000;
    top: 78px;
    height: 78px;

    .nombre-usuario {
      font-size: 24px;
      font-weight: 600;
    }

    .gestor-rooming {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }
  }

  @media (max-width: 1024px) {
    .top-block {
      margin-top: 0;
    }
  }

  @media (max-width: 767px) {
    .mt-md-10 {
      margin-top: 10rem !important;
    }
  }

  .usergestor-div {
    background-color: var(--bs-primary);
    color: var(--bs-primary);
  }

  .rooming-list {
    margin: 2rem 3.5rem 0 3.5rem;
  }

  .rooming-card {
    border-radius: var(--bs-border-radius-xl);
    background: var(--Blanco, #fff);
    box-shadow: 0px 0px 1px 0px rgba(var(--bs-primary-rgb), 0.4), 2px 4px 5px 0px rgba(var(--bs-primary-rgb), 0.1),
      4px 6px 20px 0px rgba(var(--bs-primary-rgb), 0.1);
    width: 100%;
    height: 340px;
    margin: 0;
    padding: 0;

    &.nuevo {
      border: 1px solid #f00;
    }

    .card-img-top {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }

    .card-title {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.154px;
    }

    .estado {
      max-width: 50%;
      border-radius: var(--bs-border-radius-lg);
      font-weight: 400;
      font-size: 14px;
      display: inline-flex;
      padding: 3px 8px;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
  }

  .new-badge {
    transform: rotate(45deg);
    top: 20px;
    right: -40px;
    width: 150px;
  }

  .rotate-button {
    transition: transform 0.3s ease;

    &:hover {
      transform: rotate(180deg);
    }
  }

  @media (max-width: 768px) {
    .background {
      height: 150px;
    }
  }
</style>
